module.exports = __webpack_public_path__ + "static/media/BTS_FINALS-9.13ac8b91.jpg";